import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHeartDonation: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="heart-donation, dollar"><path d="M12 5.57193C18.3331 -0.86765 29.1898 11.0916 12 20.75C-5.18982 11.0916 5.66687 -0.867651 12 5.57193Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.9702 9.125V8M11.9702 15.875V17M13.875 10.625C13.1131 9.125 10.0655 9.16425 10.0655 10.8333C10.0655 13.0057 13.875 11.9846 13.875 14.1094C13.875 15.7931 10.6369 15.875 9.875 14.375" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHeartDonation;
